import { useHistory } from 'react-router-dom'
import Layout from '@/product/components/templates/Layout'
import { useFormik } from 'formik'
import AlertContext from '@/product/context/alert/alertContext'
import React, { useContext, useState, useEffect } from 'react'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import InvoiceView from './view'
import { handleRedirectInternal } from '@/product/common/components'
import AuthContext from '@/product/context/auth/authContext'
import { currencyFormatWithDecimal } from '@/product/common/components'
import ControlHubContext from '@/product/context/controlHub/controlHubContext'
const MyInvoice = (props) => {
    const authContext = useContext(AuthContext)
    const { user, isAuthenticated } = authContext

    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext

    const history = useHistory()
    const [isLoading, setIsLoading] = useState(true)
    const [paymentInfo, setPaymentInfo] = useState({})
    const [openPopUp, setOpenPopUp] = useState(false)
    const [reload, setReload] = useState(false)
    const controlHubContext = useContext(ControlHubContext)
    const {
        getPendingPayments,
        unpaid_payment,
        payCartStripe,
        responseStatus: responseStatusPayment,
        clearResponse: clearResponsePayment,
    } = controlHubContext
    const [manage, setManage] = useState({
        popup: false,
        status: '',
        id: 0,
        action: '',
    })
    useEffect(() => {
        if (responseStatusPayment) {
            if (responseStatusPayment.status === 'error') {
                setTableBody([])
                setIsLoading(false)
            }
            clearResponsePayment()
        }
    }, [responseStatusPayment])

    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'makePayment') {
            handleRedirectInternal(history, `billing/all/${id}`)
        } else {
            const value = tableBody.find((ele) => {
                return ele.id === id
            })
            setPaymentInfo({ ...value })
            toggleFullScreenPopup(true, type, id)
        }
    }
    let action = props.match.params.action

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id, action: action })
        } else {
            setManage({ popup, status: 'new', id: 0, action: action })
        }
    }

    const [tableBody, setTableBody] = useState([])

    const formik = useFormik({
        initialValues: {
            action: action,
            searchterm: '',
            page: 1,
            limit: 20,
            order: '',
            orderby: 'pay.paid_at,desc',
            filters: {
                paid: {
                    field: 'pay.paid',
                    type: 'in',
                    value: action === 'unpaid' ? '0' : 1,
                },
            },
        },

        onSubmit: (values) => {
            setIsLoading(true)
            getPendingPayments(values, 'Invoice')
        },
    })
    useEffect(() => {
        if (action) {
            if (formik && formik.values && formik.values.filters) {
                formik.values.filters.paid.value = action === 'unpaid' ? '0' : 1
                formik.handleSubmit()
            }
        }
    }, [action])

    useEffect(() => {
        let dataVal = []

        if (unpaid_payment && unpaid_payment.records) {
            if (unpaid_payment.records.length) {
                let payments = unpaid_payment.records
                payments = payments?.map((e) => {
                    if (e.total_amount) {
                        e.total_amount = currencyFormatWithDecimal(
                            e.total_amount
                        )
                    }

                    if (e.paid == 1) {
                        e.paid = 'PAID'
                    } else {
                        e.paid = 'UNPAID'
                    }

                    return e
                })
                setTableBody(payments)
                setIsLoading(false)
            } else {
                setTableBody([])
                setIsLoading(false)
            }
        } else {
            setTableBody([])
            setIsLoading(false)
        }
    }, [unpaid_payment])
    useEffect(() => {
        if (isAuthenticated) {
            setTableBody([])
            setIsLoading(true)
            formik.values.action = action
            formik.values.page = 1
            formik.values.searchterm = ''
        }
    }, [action, isAuthenticated])
    const getMultipleAction = () => {
        let actionPush = [
            {
                buttonType: 'visibility',
                clickType: 'viewInvoice',
                onclick: onClickEdit,
                tooltipTitle: 'View Invoice',
            },
        ]

        if (action === 'unpaid') {
            actionPush.push({
                buttonType: 'monetization_on',
                clickType: 'makePayment',
                onclick: onClickEdit,
                tooltipTitle: 'Make Payment',
            })
        }

        return actionPush
    }
    const tableValues = [
        // {
        //     field: 'id',
        //     type: '',
        //     firstChild: true,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'Id',
        // },
        {
            field: 'invoice_id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Invoice ID',
        },
        // {
        //     field: 'all_apis',
        //     type: '',
        //     firstChild: true,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'API End Point',
        // },
        {
            field: 'site_id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Site ID',
        },
        {
            field: 'title',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Title',
        },
        {
            field: 'paid',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Status',
        },
        {
            field: 'total_amount',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Total Amount',
        },
    ]

    if (action === 'paid') {
        tableValues.push({
            field: 'paid_at',
            type: 'datetime',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Paid On',
        })
    }

    tableValues.push({
        name: 'action',
        field: 'action',
        type: 'button',
        isMultiple: true,
        clickID: 'id',
        sort: false,
        firstChild: false,
        disablePadding: false,
        label: 'Action',
        isMultiple: getMultipleAction(),
        tableShow: 1,
    })

    const searchInfo = [
        {
            label: 'Title',
            placeholder: 'Enter Title',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'title',
            formik: formik,
        },
    ]

    const addNewPayment = () => {
        if (formik.values.site_id) {
            toggleFullScreenPopup(true, 'payments', 0)
        } else {
            setAlert('Please Select Site ID', 'error')
        }
    }
    return (
        <Layout>
            <div className="dashboard communications">
                {/* <div className="row">{mapData(selectSiteID)}</div> */}
                {/* <CustomSearch searchInfo={searchInfo} formik={formik} /> */}
                {/* <Button variant="outlined" className="btnOutlined mr-2" onClick={addNewPayment}>
                    <span className="material-icons">note_add</span>Add New Payment
                </Button> */}
                {console.log(tableValues, 'tableValuesCheck')}
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={[]}
                    allData={unpaid_payment}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={formik.handleSubmit}
                    changeTableFromVariable={'paymentInvoice'}
                    columnStorageVariable={'table_invoice_index_view'}
                />
            </div>
            <InvoiceView
                data={manage}
                array={tableBody}
                function={toggleFullScreenPopup}
            />
        </Layout>
    )
}
export default MyInvoice
